<template>
  <div>
    <el-card>
      <div class="add_box">
        <div v-for="(item, index) in optionList" :key="index">
          <div v-if="item.type == 2">
            <h3>
              单选题:{{ item.title
              }}<el-button
                size="mini"
                type="danger"
                style="margin-left: 20px"
                @click="deleteTitle(item.id)"
                v-if="menuPerm('wenjuan:delete')"
                >删除</el-button
              >
              <el-button
                size="mini"
                type="warning"
                style="margin-left: 10px"
                @click="changeTitle(item)"
                v-if="menuPerm('wenjuan:update')"
                >修改</el-button
              >
            </h3>
            <p
              v-for="(i, ind) in item.contentList"
              :key="ind"
              style="margin-left: 30px"
            >
              {{ i.content }}
            </p>
          </div>
          <div v-if="item.type == 3">
            <h3>
              多选题:{{ item.title }}
              <el-button
                size="mini"
                type="danger"
                style="margin-left: 20px"
                @click="deleteTitle(item.id)"
                v-if="menuPerm('wenjuan:delete')"
                >删除</el-button
              >
              <el-button
                size="mini"
                type="warning"
                style="margin-left: 10px"
                @click="changeTitle(item)"
                v-if="menuPerm('wenjuan:update')"
                >修改</el-button
              >
            </h3>
            <p
              v-for="(i, ind) in item.contentList"
              :key="ind"
              style="margin-left: 30px"
            >
              {{ i.content }}
            </p>
          </div>
          <div v-if="item.type == 1">
            <h3>
              填空:{{ item.title }}
              <el-button
                size="mini"
                type="danger"
                style="margin-left: 20px"
                @click="deleteTitle(item.id)"
                v-if="menuPerm('wenjuan:delete')"
                >删除</el-button
              >
              <el-button
                size="mini"
                type="warning"
                style="margin-left: 10px"
                @click="changeTitle(item)"
                v-if="menuPerm('wenjuan:update')"
                >修改</el-button
              >
            </h3>
          </div>
        </div>
        <el-button
          size="mini"
          type="primary"
          @click="addTitle"
          v-if="menuPerm('wenjuan:insert')"
          >添加题目</el-button
        >
      </div>
    </el-card>
    <el-card style="margin-top: 10px" v-if="isShow">
      <div style="margin-top: 30px">
        <el-radio-group v-model="radio" style="margin-bottom: 20px">
          <el-radio :label="2">单选</el-radio>
          <el-radio :label="3">多选</el-radio>
          <el-radio :label="1">填空</el-radio>
        </el-radio-group>
        <el-form
          :model="addList"
          :rules="toEdRule"
          :label-position="labelPosition"
          class="boxForm"
          ref="ruleForm"
        >
          <el-form-item label="题目">
            <el-input v-model="addList.title"></el-input>
          </el-form-item>

          <el-form-item
            label="排序(越小越靠前)"
            label-width="50px"
            style="margin-bottom: 0"
          >
            <el-input
              v-model="addList.sort"
              type="number"
              style="width: 100px"
            ></el-input>
          </el-form-item>
          <a-form :form="form" @submit="handleSubmit">
            <a-form-item
              v-for="(k, index) in form.getFieldValue('keys')"
              :key="k"
              v-bind="index === 0 ? formItemLayout : formItemLayoutWithOutLabel"
              :required="false"
            >
              <a-input
                v-decorator="[
                  `names[${k}]`,
                  {
                    validateTrigger: ['change', 'blur'],
                    rules: [
                      {
                        required: true,
                        whitespace: true,
                        message: '请输入选项',
                      },
                    ],
                  },
                ]"
                placeholder="请输入选项"
                style="width: 60%; margin-right: 8px"
              />
              <a-icon
                v-if="form.getFieldValue('keys').length > 1"
                class="dynamic-delete-button"
                type="minus-circle-o"
                :disabled="form.getFieldValue('keys').length === 1"
                @click="() => remove(k)"
              />
            </a-form-item>
            <a-form-item v-bind="formItemLayoutWithOutLabel">
              <a-button
                type="dashed"
                style="width: 60%"
                @click="add"
                :disabled="disabled"
              >
                <a-icon type="plus" /> 添加选项
              </a-button>
            </a-form-item>
            <a-form-item v-bind="formItemLayoutWithOutLabel">
              <a-button type="primary" html-type="submit" @click="submit">
                保存
              </a-button>
            </a-form-item>
          </a-form>
          <!-- <el-row>
              <el-col :span="10">
                <el-button size="mini" type="primary" @click="submit"
                  >保存</el-button
                >
              </el-col>
            </el-row> -->
        </el-form>
      </div>
    </el-card>
    <!-- 修改选项 -->
    <a-modal
      title="修改选项"
      :visible="changeOpen"
      ok-text="确认"
      cancel-text="取消"
      @cancel="handleCancel"
      :footer="null"
    >
      <el-form
        :model="changeOption"
        label-position="left"
        label-width="80px"
        ref="ruleForm"
        style="marginleft: -70px"
      >
        <el-row>
          <el-form-item label="题目" prop="title">
            <el-input
              placeholder="请输入内容"
              v-model="changeOption.title"
              clearable
            />
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input
              placeholder="请输入内容"
              v-model="changeOption.sort"
              clearable
              style="width: 150px"
              type="number"
            />
          </el-form-item>
          <el-form-item label="选项">
            <el-form-item
              v-for="(item, index) in changeOption.contentList"
              :key="index"
            >
              <el-input
                placeholder="请输入内容"
                v-model="item.content"
                style="margin-bottom: 10px"
              ></el-input>
            </el-form-item>
          </el-form-item>
        </el-row>
        <el-row>
          <el-button
            style="margin-left: 200px"
            type="primary"
            @click="changeSuccess"
            >保存</el-button
          >
        </el-row>
      </el-form>
    </a-modal>
  </div>
</template>
<script>
let id = 0;
export default {
  props: ["Detaildata"],
  watch: {
    Detaildata(newVal, oldVal) {
      this.getList(newVal.id);
    },
    radio(newVal, oldVal) {
      if (newVal == 1) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
  },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
      },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 },
        },
      },
      labelPosition: "top",
      radio: 2,
      addList: {
        title: "",
        sort: "",
      },
      toEdRule: {},
      optionList: [],
      isShow: false,
      contentList: [],
      disabled: false,
      changeOpen: false,
      changeOption: "",
    };
  },
  mounted() {
    this.getList(this.Detaildata.id);
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "dynamic_form_item" });
    this.form.getFieldDecorator("keys", { initialValue: [], preserve: true });
  },
  methods: {
    // 修改成功
    changeSuccess() {
      this.postAxios("/wenjuan/update/option", {
        id: this.changeOption.id,
        wenjuanId: this.Detaildata.id,
        type: this.changeOption.type,
        title: this.changeOption.title,
        contentList: this.changeOption.contentList,
        sort: this.changeOption.sort,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
          this.changeOpen = false;
          this.getList(this.Detaildata.id);
        }
      });
    },
    // 删除取消弹框
    handleCancel() {
      this.changeOpen = false;
    },
    getList(id) {
      this.getAxios(`/wenjuan/detail?id=${id}`).then((res) => {
        this.optionList = res.entity.optionList;
      });
    },
    // 添加题目
    addTitle() {
      this.isShow = true;
      this.radio = 2;
      this.addList = {};
      const { form } = this;
      // can use data-binding to get
      const keys = form.getFieldValue("keys");
      // We need at least one passenger
      // can use data-binding to set
      form.setFieldsValue({
        keys:[],
      });
    },
    // 删除
    deleteTitle(id) {
      this.getAxios(`/wenjuan/delete/option?optionId=${id}`).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
          this.getList(this.Detaildata.id);
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (res.success == false && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    // 修改
    changeTitle(obj) {
      this.changeOpen = true;
      this.changeOption = obj;
    },
    submit() {},
    remove(k) {
      const { form } = this;
      // can use data-binding to get
      const keys = form.getFieldValue("keys");
      // We need at least one passenger
      if (keys.length === 1) {
        return;
      }
      // can use data-binding to set
      form.setFieldsValue({
        keys: keys.filter((key) => key !== k),
      });
    },

    add() {
      const { form } = this;
      // can use data-binding to get
      const keys = form.getFieldValue("keys");
      const nextKeys = keys.concat(id++);
      // can use data-binding to set
      // important! notify form to detect changes
      form.setFieldsValue({
        keys: nextKeys,
      });
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          const { keys, names } = values;
          // console.log(keys.map((key) => names[key]));
          if (this.radio != 1) {
            this.contentList=[]
            names.map((i) => {
              this.contentList.push({
                content: i,
              });
            });
          }
          this.postAxios("/wenjuan/add/option", {
            wenjuanId: this.Detaildata.id, //问卷调查的id
            type: this.radio,
            title: this.addList.title,
            contentList: this.contentList, //如果不是填空题，则把选项填到这里
            sort: this.addList.sort, //排名
          }).then((res) => {
            if (res.success == true) {
              this.isShow = false;
              this.addList = {};
              this.$message.success(res.message);
              this.form.resetFields();
              this.getList(this.Detaildata.id);
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (res.success == false && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
h3 {
  font-weight: bold;
}
/deep/ .boxForm .el-form-item__label {
  float: left !important;
  width: 110px;
}
/deep/ .boxForm .el-form-item__content {
  width: 400px;
  float: left !important;
  margin-left: 10px;
}
/deep/ .boxForm .ant-col-xs-24 {
  margin-left: 120px;
}
</style>